// import {
//   CCol,
//   CFormInput,
//   CFormLabel,
//   CLoadingButton,
//   CRow,
// } from "@coreui/react-pro";
// import { socket } from "@/shared/config/socket";
// import { useEffect, useRef, useState } from "react";
// import { formatUSD } from "@/shared/utils/ultils";
// import { ToastError, ToastSuccess } from "@/components/shared/toast/Toast";
// import axios from "../../../shared/config/axios-interceptor";

// const DatCuocPc = ({
//   userId,
//   phienId,
//   setLoad,
//   load,
//   game,
// }: {
//   userId: string;
//   phienId: string;
//   setLoad: (load: boolean) => void;
//   load: boolean;
//   game: any;
// }) => {
//   const [listCuoc, setListCuoc] = useState<any>([]);
//   const [selectedCuoc, setSelectedCuoc] = useState<any[]>([]);
//   const inputRef = useRef<HTMLInputElement | null>(null);
//   const [money, setMoney] = useState<string>("");
//   const [loading, setLoading] = useState<boolean>(false);

//   useEffect(() => {
//     socket.on("get_prices", (data: any) => {
//       if (game?.imageDesktop != null && game?.imageDesktop != "1.98") {
//         data.forEach((item: any) => {
//           item.rate = game?.imageDesktop;
//         });
//       }
//       setListCuoc(data);
//     });
//   }, []);

//   const toggleCuoc = (item: any) => {
//     setSelectedCuoc((prev) => {
//       const isSelected = prev.some((cuoc) => cuoc.name === item.name);
//       if (isSelected) {
//         return prev.filter((cuoc) => cuoc.name !== item.name);
//       } else {
//         return [...prev, item];
//       }
//     });
//   };

//   const onSubmit = async () => {
//     if (!money || Number(money) <= 0 || isNaN(Number(money))) {
//       ToastError("Số tiền phải lớn hơn 0");
//       return;
//     }

//     if (selectedCuoc.length === 0) {
//       ToastError("Vui lòng chọn hàng hóa");
//       return;
//     }
//     try {
//       setLoading(true);
//       await axios.post("/history", {
//         drawId: phienId,
//         money,
//         userId: userId,
//         cuocSelected: selectedCuoc,
//       });
//       setLoading(false);
//       setMoney("");
//       setSelectedCuoc([]);
//       ToastSuccess("Xác nhận thành công!");
//       inputRef?.current?.focus();
//       setLoad(!load);
//     } catch (error) {
//       setLoading(false);
//       console.log(error);
//     }
//   };

//   return (
//     <>
//       <CRow className="g-3 justify-content-center">
//         {listCuoc?.map((item: any, index: number) => {
//           const isSelected = selectedCuoc.some(
//             (cuoc) => cuoc.name === item.name
//           );
//           return (
//             <CCol
//               md={4}
//               key={index}
//               style={{ cursor: "pointer" }}
//               onClick={() => toggleCuoc(item)}
//             >
//               <div
//                 className="d-flex p-2 flex-column align-items-center justify-content-between gap-1"
//                 style={{
//                   color: isSelected ? "#000" : "#fff",
//                   background: isSelected ? "hsl(49 92% 54%)" : "rgb(7, 15, 34)",
//                   borderRadius: 5,
//                 }}
//               >
//                 <div className="d-flex align-items-center gap-2">
//                   <img
//                     src={`https://gialuongthucthegioi.com/assets/images/commodity/${item?.image}`}
//                     width={26}
//                     height={26}
//                     className="rounded-circle"
//                     style={{ border: "1px solid #000" }}
//                   />
//                   <span style={{ fontSize: 12 }}>{item?.name}</span>
//                 </div>

//                 <p className="mb-1 mt-1" style={{ fontSize: 14 }}>
//                   {item?.rate}
//                 </p>
//                 <div
//                   className="w-100 d-flex justify-content-center gap-2"
//                   style={{ fontSize: 13 }}
//                 >
//                   {/* <p className="mb-0">{item?.name}</p> */}
//                   <p
//                     className="mb-0"
//                     style={{
//                       color: isSelected ? "#000" : "rgb(246, 206, 30)",
//                     }}
//                   >
//                     {formatUSD(item?.price)}
//                   </p>
//                 </div>
//               </div>
//             </CCol>
//           );
//         })}
//       </CRow>

//       <div className="my-3">
//         <CFormLabel style={{ color: "#fff", fontSize: 14 }}>
//           Khối lượng chip
//         </CFormLabel>
//         <CFormInput
//           ref={inputRef}
//           placeholder="Số lượng"
//           type="text"
//           style={{
//             background: "rgb(7, 15, 33)",
//             color: "#fff",
//             border: "none",
//             height: 50,
//             boxShadow: "none",
//           }}
//           value={money}
//           onChange={(e) => setMoney(e.target.value)}
//         />
//       </div>

//       <div>
//         <CLoadingButton
//           onClick={onSubmit}
//           disabled={loading}
//           loading={loading}
//           className="w-100"
//           style={{
//             background: "rgb(246, 206, 30)",
//             color: "#fff",
//             height: 50,
//             fontWeight: "bold",
//           }}
//         >
//           XÁC NHẬN Xác nhận
//         </CLoadingButton>
//       </div>
//     </>
//   );
// };

// export default DatCuocPc;

import {
  CCol,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CRow,
} from "@coreui/react-pro";
import { socket } from "@/shared/config/socket";
import { useEffect, useRef, useState } from "react";
import { formatUSD, formatVNDNoDecimals } from "@/shared/utils/ultils";
import { ToastError, ToastSuccess } from "@/components/shared/toast/Toast";
import axios from "../../../shared/config/axios-interceptor";

const DatCuocPc = ({
  userId,
  phienId,
  setLoad,
  load,
  game,
  user,
}: {
  userId: string;
  phienId: string;
  setLoad: (load: boolean) => void;
  load: boolean;
  game: any;
  user: any;
}) => {
  const [listCuoc, setListCuoc] = useState<any>([]);
  const [selectedCuoc, setSelectedCuoc] = useState<any[]>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [money, setMoney] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    socket.on("get_prices", (data: any) => {
      // Nếu gameId == 1 thì lấy các name = ['Coffee', 'Gạo', 'Lúa mỳ', 'Đậu Nành']
      // Nếu gameId == 2 thì lấy các name = ['Vàng', 'Bạc', 'Titanium', 'Platinum']
      // Nếu gameId == 3 thì lấy các name = ['Dầu', 'Gas', 'Uranium']
      if (game?.imageDesktop != null && game?.imageDesktop != "1.98") {
        data.forEach((item: any) => {
          item.rate = game?.imageDesktop;
        });
      }
      if (game?.id == 1) {
        setListCuoc(
          data.filter((item: any) =>
            ["Coffee", "Gạo", "Lúa mỳ", "Đậu Nành"].includes(item.name)
          )
        );
      } else if (game?.id == 2) {
        setListCuoc(
          data.filter((item: any) =>
            ["Vàng", "Bạc", "Titanium", "Platinum"].includes(item.name)
          )
        );
      } else if (game?.id == 3) {
        setListCuoc(
          data.filter((item: any) =>
            ["Dầu", "Gas", "Uranium"].includes(item.name)
          )
        );
      }
    });
  }, [game]);

  const toggleCuoc = (item: any, type: string) => {
    const newName = item?.name + " " + type;
    setSelectedCuoc((prev) => {
      const isSelected = prev.some((cuoc) => cuoc.name === newName);
      if (isSelected) {
        return prev.filter((cuoc) => cuoc.name !== newName);
      } else {
        return [
          ...prev,
          { name: newName, price: item?.price, rate: item?.rate },
        ];
      }
    });
  };

  const onSubmit = async () => {
    if (!money || Number(money) <= 0 || isNaN(Number(money))) {
      ToastError("Số tiền phải lớn hơn 0");
      return;
    }

    if (selectedCuoc.length === 0) {
      ToastError("Vui lòng chọn hàng hóa");
      return;
    }
    try {
      setLoading(true);
      await axios.post("/history", {
        drawId: phienId,
        money,
        userId: userId,
        cuocSelected: selectedCuoc,
      });
      setLoading(false);
      setMoney("");
      setSelectedCuoc([]);
      ToastSuccess("Xác nhận thành công!");
      inputRef?.current?.focus();
      setLoad(!load);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      <CRow>
        <CCol xs={6}>
          <h6 className="text-center mt-2 mb-2" style={{ color: "green" }}>
            MUA
          </h6>
          <CRow className="g-3 justify-content-center">
            {listCuoc?.map((item: any, index: number) => {
              const isSelected = selectedCuoc.some(
                (cuoc) => cuoc.name === item.name + " Mua"
              );
              return (
                <CCol
                  xs={12}
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleCuoc(item, "Mua")}
                >
                  <div
                    className="d-flex p-2 align-items-center justify-content-between gap-1"
                    style={{
                      color: isSelected ? "#000" : "#fff",
                      background: isSelected
                        ? "hsl(49 92% 54%)"
                        : "rgb(7, 15, 34)",
                      borderRadius: 5,
                    }}
                  >
                    <img
                      src={`https://gialuongthucthegioi.com/assets/images/commodity/${item?.image}`}
                      width={32}
                      height={32}
                      className="rounded-circle"
                      style={{ border: "1px solid #000" }}
                    />
                    <div style={{ fontSize: 12 }}>
                      <p className="mb-2">{item?.name}</p>
                      <p
                        className="m-0"
                        style={{
                          color: isSelected ? "#000" : "rgb(246, 206, 30)",
                        }}
                      >
                        {formatUSD(item?.price)}
                      </p>
                    </div>
                    <p>{item?.rate}</p>
                  </div>
                </CCol>
              );
            })}
          </CRow>
        </CCol>

        <CCol xs={6}>
          <h6 className="text-center mt-2 mb-2" style={{ color: "red" }}>
            BÁN
          </h6>
          <CRow className="g-3 justify-content-center">
            {listCuoc?.map((item: any, index: number) => {
              const isSelected = selectedCuoc.some(
                (cuoc) => cuoc.name === item.name + " Bán"
              );
              return (
                <CCol
                  xs={12}
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleCuoc(item, "Bán")}
                >
                  <div
                    className="d-flex p-2 align-items-center justify-content-between gap-1"
                    style={{
                      color: isSelected ? "#000" : "#fff",
                      background: isSelected
                        ? "hsl(49 92% 54%)"
                        : "rgb(7, 15, 34)",
                      borderRadius: 5,
                    }}
                  >
                    <img
                      src={`https://gialuongthucthegioi.com/assets/images/commodity/${item?.image}`}
                      width={32}
                      height={32}
                      className="rounded-circle"
                      style={{ border: "1px solid #000" }}
                    />
                    <div style={{ fontSize: 12 }}>
                      <p className="mb-2">{item?.name}</p>
                      <p
                        className="m-0"
                        style={{
                          color: isSelected ? "#000" : "rgb(246, 206, 30)",
                        }}
                      >
                        {formatUSD(item?.price)}
                      </p>
                    </div>
                    <p>{item?.rate}</p>
                  </div>
                </CCol>
              );
            })}
          </CRow>
        </CCol>
      </CRow>

      <div className="my-3">
        <CFormInput
          ref={inputRef}
          placeholder="Số lượng"
          type="text"
          style={{
            background: "rgb(7, 15, 33)",
            color: "#fff",
            border: "none",
            height: 50,
            boxShadow: "none",
          }}
          className="text-white input-text-white"
          value={money}
          onChange={(e) => setMoney(e.target.value)}
        />
      </div>

      <div>
        <CLoadingButton
          onClick={onSubmit}
          disabled={loading}
          loading={loading}
          className="w-100"
          style={{
            background: "rgb(246, 206, 30)",
            color: "#000",
            height: 50,
            fontWeight: "bold",
          }}
        >
          XÁC NHẬN
        </CLoadingButton>
      </div>
    </>
  );
};

export default DatCuocPc;
